<template>
  <v-container fluid>
    <v-card>
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Finalizar Compra</v-toolbar-title>
        <v-spacer />
        <v-badge
          bordered
          color="error"
          :content="$store.state.produtos.length"
          overlap
          v-if="$store.state.produtos.length > 0"
        >
          <v-icon>mdi-cart</v-icon>
        </v-badge>
        <v-icon v-else>mdi-cart</v-icon>
      </v-app-bar>

      <v-row dense v-if="$store.state.produtos.length === 0">
        <v-col class="px-4 py-8 text-center"
          >Seu carrinho de compras está vazio</v-col
        >
        <v-col cols="12" class="text-center pa-4">
          <v-btn depressed @click="$router.push('/')"
            >Continuar Comprando</v-btn
          >
        </v-col>
      </v-row>

      <v-row dense v-else>
        <v-col cols="12" class="pa-4 pb-0">
          <v-tabs vertical v-model="tab_atual">
            <v-tab
              style="justify-content: start; min-width: 24px !important"
              class="pr-1"
              href="#produtos"
            >
              <v-icon left>mdi-cart</v-icon>
              <span class="hidden-xs-only">Produtos</span>
            </v-tab>
            <v-tab
              style="justify-content: start; min-width: 24px !important"
              class="pr-1"
              href="#entrega"
              v-if="user.tipo != 'fornecedor'"
            >
              <v-icon left>mdi-map-marker</v-icon>
              <span class="hidden-xs-only">Local de Entrega</span>
            </v-tab>
            <v-tab
              style="justify-content: start; min-width: 24px !important"
              class="pr-1"
              href="#cliente"
              v-if="user.tipo === 'fornecedor'"
            >
              <v-icon left>mdi-account</v-icon>
              <span class="hidden-xs-only">Cliente</span>
            </v-tab>
            <v-tab
              style="justify-content: start; min-width: 24px !important"
              class="pr-1"
              href="#pagamento"
              :disabled="!empresa.cliente_id"
              @click="setarValorLiquido"
            >
              <v-icon left>mdi-currency-usd</v-icon>
              <span class="hidden-xs-only">Pagamento</span>
            </v-tab>

            <v-tabs-items v-model="tab_atual">
              <v-tab-item
                :transition="false"
                :reverse-transition="false"
                class="ml-2 pl-3"
                style="border-left: 1px solid lightgrey"
                value="produtos"
              >
                <!-- produtos -->
                <v-card
                  v-for="(item, index) in $store.state.produtos"
                  :key="index"
                  class="mb-2 pr-2"
                >
                  <div style="display: flex; flex-direction: row">
                    <v-avatar
                      class="ma-3"
                      size="68"
                      tile
                      @click="editarGrade(item, index)"
                    >
                      <v-img
                        :src="item.fotos[0]"
                        style="border-radius: 4px; border: 1px solid #eee; cursor: pointer"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="grey lighten-5"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                    <div style="overflow: hidden">
                      <v-card-subtitle
                        class="headline pt-2 pb-0 pl-0 text--primary"
                        style="text-overflow: ellipsis; overflow: hidden; display: block; font-size: 1.2rem !important"
                        >{{ item.descricao }}</v-card-subtitle
                      >
                      <v-card-subtitle
                        class="py-0 pl-0"
                        style="font-size: 0.8rem; font-weight: 300"
                        >Código - {{ item.id }}</v-card-subtitle
                      >

                      <v-card-subtitle class="pb-2 pt-1 pl-0">
                        <span>{{ item.quantidade }}</span> x
                        <span>R$ {{ item.valor | valorBR }}</span>
                        <span
                          class="hidden-xs-only"
                          style="background-color: dimgrey; color: white; border-radius: 4px; padding: 0px 4px; margin-left: 6px"
                          >R$ {{ item.subtotal | valorBR }}</span
                        >
                      </v-card-subtitle>
                    </div>

                    <v-list-item-icon class="mr-4 my-auto ml-auto">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            fab
                            depressed
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="$store.commit('removerItemCarrinho', index)"
                          >
                            <v-icon color="red">mdi-cart-remove</v-icon>
                          </v-btn>
                        </template>
                        <span>Excluir Produto</span>
                      </v-tooltip>
                    </v-list-item-icon>
                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item
                :transition="false"
                :reverse-transition="false"
                value="entrega"
                class="ml-2 pl-3"
                style="border-left: 1px solid lightgrey"
              >
                <v-row
                  dense
                  class="ml-2"
                  style="border-left: 1px solid lightgrey"
                >
                  <!-- entrega -->
                  <v-col cols="12" class="pt-0 pb-2 pl-3 pr-1">
                    <v-row dense v-if="user.tipo == 'representante'">
                      <v-col cols="12">
                        <v-autocomplete
                          v-model="cliente"
                          :items="clientes"
                          label="Cliente"
                          ref="cliente"
                          item-text="responsavel_nome"
                          return-object
                          @change="carregarEmpresas"
                        />
                      </v-col>
                    </v-row>
                    <v-row dense v-if="empresa.nome_fantasia.length > 0">
                      <v-col cols="9" class="align-center">
                        <span class="text--primary" style="font-size: 20px">
                          <b>{{ empresa.nome_fantasia }}</b>
                        </span>
                        <br />
                        <span class="text--primary">{{ empresa.cnpj }}</span>
                        <br />
                        <span class="text--primary"
                          >{{ empresa.endereco.rua }},
                          {{ empresa.endereco.numero }},
                          {{ empresa.endereco.bairro }}</span
                        >
                        <br />
                        <span class="text--primary"
                          >CEP - {{ empresa.endereco.cep }}</span
                        >
                        <br />
                        <span class="text--primary">{{
                          empresa.endereco.local
                        }}</span>
                      </v-col>
                      <v-col cols="3" style="text-align: right">
                        <v-btn
                          fab
                          small
                          depressed
                          color="primary"
                          class="mr-2"
                          @click="$refs.dialogoSelecaoEmpresa.abrir()"
                        >
                          <v-icon color="white">mdi-pencil</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row dense v-else>
                      <v-col v-if="user.tipo == 'cliente'">
                        <v-label class="text--primary"
                          >Para finalizar sua compra, é necessário ter ao menos
                          uma empresa cadastrada!</v-label
                        >
                        <br />
                        <br />
                        <v-label class="text--primary"
                          >Você ainda não cadastrou nenhuma empresa. Clique no
                          botão abaixo para cadastrar sua primeira empresa
                          agora.</v-label
                        >
                        <br />
                        <br />
                        <v-btn
                          depressed
                          color="primary"
                          @click="$router.push('/empresas/cadastrar')"
                          >Cadastrar Empresa</v-btn
                        >
                      </v-col>
                      <v-col v-else>
                        <v-label class="text--primary"
                          >Para finalizar sua compra, é necessário selecionar um
                          cliente acima!</v-label
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item
                :transition="false"
                :reverse-transition="false"
                value="cliente"
                v-if="user.tipo === 'fornecedor'"
                class="ml-2 pl-3"
                style="border-left: 1px solid lightgrey"
              >
                <v-row dense>
                  <v-row dense>
                    <v-col cols="12" sm="2">
                      <v-text-field
                        label="Código"
                        append-icon="search"
                        @click="$refs.dialogoPesquisaCliente.abrir()"
                        @click:append="$refs.dialogoPesquisaCliente.abrir()"
                        v-model="empresa.cliente_id"
                        v-if="user.tipo == 'fornecedor'"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                      <v-text-field
                        label="Código"
                        v-model="empresa.cliente_id"
                        v-if="user.tipo == 'representante'"
                        readonly
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="5">
                      <v-text-field
                        label="Razão Social"
                        readonly
                        v-model="empresa.razao_social"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="5">
                      <v-text-field
                        label="Nome Fantasia"
                        readonly
                        v-model="empresa.nome_fantasia"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        label="CNPJ/CPF"
                        readonly
                        v-model="empresa.cnpj"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        label="Representante"
                        readonly
                        v-model="empresa.representante_nome"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" sm="5">
                      <v-text-field
                        label="Rua"
                        readonly
                        v-model="empresa.endereco.rua"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="2">
                      <v-text-field
                        label="Número"
                        readonly
                        v-model="empresa.endereco.numero"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="5">
                      <v-text-field
                        label="Bairro"
                        readonly
                        v-model="empresa.endereco.bairro"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" sm="5">
                      <v-text-field
                        label="Cidade"
                        readonly
                        v-model="empresa.endereco.cidade"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        label="Estado"
                        readonly
                        v-model="empresa.endereco.estado"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3">
                      <v-text-field
                        label="CEP"
                        readonly
                        v-model="empresa.endereco.cep"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="user.tipo == 'representante'">
                    <v-col cols="12" sm="4">
                      <v-text-field
                        label="Email"
                        readonly
                        v-model="empresa.endereco.email"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        label="Telefone"
                        readonly
                        v-model="empresa.endereco.telefone"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4">
                      <v-text-field
                        label="Celular"
                        readonly
                        v-model="empresa.endereco.celular"
                        backgroundColor="#f8f8f8"
                        hideDetails
                        filled
                        placeholder=" "
                        persistent-placeholder
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-row>
              </v-tab-item>

              <v-tab-item
                :transition="false"
                :reverse-transition="false"
                value="pagamento"
                class="ml-2 pl-3"
                style="border-left: 1px solid lightgrey"
              >
                <v-row dense v-if="user.tipo != 'fornecedor'">
                  <!-- pagamento -->
                  <v-col cols="12" class="pt-1 pb-2 pl-3 pr-1">
                    <v-row dense v-if="empresa.nome_fantasia.length > 0">
                      <v-col cols="12" sm="6">
                        <v-label>Forma de Pagamento</v-label>
                        <v-radio-group v-model="forma_pagamento">
                          <v-radio
                            label="Depósito em Conta Corrente"
                            value="Depósito"
                          />
                          <v-radio label="PIX" value="PIX" disabled />
                          <v-radio label="Cheque" value="Cheque" disabled />
                          <v-radio label="TED" value="TED" disabled />
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <div v-if="forma_pagamento == 'Depósito'">
                          <div style="margin-top: 15px">
                            <span class="text--primary" style="font-size: 20px">
                              <b>{{ representante.nome_fantasia }}</b>
                            </span>
                            <br />
                            <span class="text--primary">{{
                              representante.cnpj
                            }}</span>
                            <br />
                            <span class="text--primary">
                              <b>{{ representante.banco }}</b>
                            </span>
                            <br />
                            <span class="text--primary">
                              Agência
                              <b>{{ representante.agencia }}</b>
                            </span>
                            <br />
                            <span class="text--primary">
                              {{ representante.conta_tipo }}
                              <b>{{ representante.conta }}</b>
                            </span>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row dense v-else>
                  <v-form
                    ref="form"
                    v-model="form_pagamento"
                    style="width:100%"
                    lazy-validation
                  >
                    <v-row dense>
                      <v-col cols="12" sm="2">
                        <as-date-picker-menu
                          label="Data do Pedido"
                          v-model="pagamento.data"
                          ref="data"
                          readonly
                          :rules="rules.data"
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></as-date-picker-menu>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <as-date-picker-menu
                          label="Entrega"
                          v-model="pagamento.entrega"
                          ref="entrega"
                          @keydown.native.enter="
                            $refs.desconto_percentual.focus()
                          "
                          :min="data_atual"
                          :rules="rules.entrega"
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></as-date-picker-menu>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <as-campo-valor
                          label="Desconto %"
                          v-model="pagamento.desconto_percentual"
                          ref="desconto_percentual"
                          @keydown.native.enter="$refs.desconto_valor.focus()"
                          @keyup.native="calcularDescontoValor"
                          :rules="rules.valor_zerado"
                          :readonly="user.tipo == 'representante'"
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></as-campo-valor>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <as-campo-valor
                          label="Desconto Valor"
                          v-model="pagamento.desconto_valor"
                          ref="desconto_valor"
                          @keydown.native.enter="$refs.taxa_percentual.focus()"
                          @keyup.native="calcularDescontoPercentual"
                          :rules="rules.valor_zerado"
                          :readonly="user.tipo == 'representante'"
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></as-campo-valor>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <as-campo-valor
                          label="Taxa %"
                          v-model="pagamento.taxa_percentual"
                          ref="taxa_percentual"
                          @keydown.native.enter="$refs.taxa_valor.focus()"
                          @keyup.native="calcularTaxaValor"
                          :rules="rules.valor_zerado"
                          :readonly="user.tipo == 'representante'"
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></as-campo-valor>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <as-campo-valor
                          label="Taxa Valor"
                          v-model="pagamento.taxa_valor"
                          ref="taxa_valor"
                          @keydown.native.enter="$refs.forma_pagamento.focus()"
                          @keyup.native="calcularTaxaPercentual"
                          :rules="rules.valor_zerado"
                          :readonly="user.tipo == 'representante'"
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></as-campo-valor>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="2">
                        <as-campo-valor
                          label="Comissão %"
                          v-model="pagamento.comissao_percentual"
                          ref="comissao_percentual"
                          @keydown.native.enter="$refs.comissao_valor.focus()"
                          readonly
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></as-campo-valor>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <as-campo-valor
                          label="Comissão Valor"
                          v-model="pagamento.comissao_valor"
                          ref="comissao_valor"
                          @keydown.native.enter="$refs.comissao_tipo.focus()"
                          readonly
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></as-campo-valor>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <v-select
                          label="Comissão Tipo"
                          v-model="pagamento.comissao_tipo"
                          :items="comissao_tipo"
                          ref="comissao_tipo"
                          @keydown.native.enter="$refs.forma_pagamento.focus()"
                          readonly
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-select
                          label="Forma de Pagamento"
                          v-model="pagamento.forma_pagamento"
                          :items="formas_pagamento_fornecedor"
                          ref="forma_pagamento"
                          @keydown.native.enter="$refs.prazo.focus()"
                          :rules="rules.forma_pagamento"
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-select>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-combobox
                          v-model="pagamento.prazo"
                          :items="prazos"
                          label="Prazo de Pagamento"
                          ref="prazo"
                          @keydown.native.enter="$refs.transportadora.focus()"
                          :rules="rules.prazo"
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-combobox>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          label="Transportadora"
                          v-model="pagamento.transportadora"
                          ref="transportadora"
                          @keydown.native.enter="
                            $refs.transportadora_telefone.focus()
                          "
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                          autocomplete="off"
                          role="presentation"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="3">
                        <v-text-field
                          label="Transportadora Telefone"
                          v-model="pagamento.transportadora_telefone"
                          ref="transportadora_telefone"
                          v-mask="
                            pagamento.transportadora_telefone.replace(/\D/g, '')
                              .length <= 10
                              ? '(##) ####-####'
                              : '(##) #####-####'
                          "
                          :return-masked-value="true"
                          @keydown.native.enter="$refs.vendedor.focus()"
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                          autocomplete="off"
                          role="presentation"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <v-text-field
                          label="Responsável"
                          v-model="pagamento.vendedor"
                          ref="vendedor"
                          @keydown.native.enter="$refs.valor_bruto.focus()"
                          :rules="rules.vendedor"
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                          autocomplete="off"
                          role="presentation"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <as-campo-valor
                          label="Valor Bruto"
                          v-model="valorTotal"
                          ref="valor_bruto"
                          @keydown.native.enter="$refs.valor_liquido.focus()"
                          readonly
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></as-campo-valor>
                      </v-col>
                      <v-col cols="12" sm="2">
                        <as-campo-valor
                          label="Valor Líquido"
                          v-model="pagamento.valor_liquido"
                          ref="valor_liquido"
                          @keydown.native.enter="$refs.observacoes.focus()"
                          readonly
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></as-campo-valor>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="12">
                        <v-textarea
                          label="Observações"
                          v-model="pagamento.observacoes"
                          ref="observacoes"
                          backgroundColor="#f8f8f8"
                          hideDetails
                          filled
                          placeholder=" "
                          persistent-placeholder
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-tabs>
        </v-col>

        <v-col cols="12" class="px-4 pb-2">
          <!-- totais -->
          <v-row dense>
            <v-col cols="12" sm="3" md="2" class="pa-0 px-1">
              <v-chip
                class="ma-2 mx-0"
                label
                style="width: 100%; display: grid"
              >
                <span>Itens</span>
                <v-spacer />
                <span>
                  <b>{{ $store.state.produtos.length }}</b>
                </span>
              </v-chip>
            </v-col>

            <v-col cols="12" sm="4" md="3" class="pa-0 px-1">
              <v-chip
                class="ma-2 mx-0"
                label
                style="width: 100%; display: grid"
              >
                <span>Quantidade Total</span>
                <v-spacer />
                <span>
                  <b>{{ quantidadeTotal }}</b>
                </span>
              </v-chip>
            </v-col>
            <v-col cols="12" sm="5" md="3" class="pa-0 px-1">
              <v-chip
                class="mt-2 pr-0"
                label
                style="width: 100%; display: grid"
              >
                <span>Valor Total</span>
                <v-spacer />
                <v-chip color="primary" label>
                  <h3>R$ {{ valorTotal | valorBR }}</h3>
                </v-chip>
              </v-chip>
            </v-col>

            <v-col
              class="pa-0 px-1 hidden-sm-and-down"
              cols="12"
              sm="12"
              md="4"
              style="align-items: center; display: flex; justify-content: flex-end"
            >
              <v-btn depressed @click="$router.push('/')">Voltar à Loja</v-btn>
              <v-btn
                depressed
                @click="finalizarCompra"
                dark
                color="primary"
                class="ml-2"
                >Finalizar</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-card-actions class="pa-3 hidden-md-and-up">
        <v-spacer />
        <v-btn depressed @click="$router.push('/')">Voltar à Loja</v-btn>
        <v-btn
          depressed
          @click="finalizarCompra"
          dark
          color="primary"
          class="ml-2"
          >Finalizar</v-btn
        >
      </v-card-actions>

      <grade ref="grade" idWindow="a" />

      <as-dialogo
        ref="dialogoSelecaoEmpresa"
        title="Selecionar Local de Entrega"
        max-width="960px"
        hideCloseButton
      >
        <v-label>Selecione a empresa que esse pedido deve ser enviado</v-label>
        <v-divider class="mt-3 mb-1"></v-divider>
        <v-data-table
          :headers="headers_empresas"
          :items="empresas"
          hide-default-footer
          :loading="loading"
          no-data-text="Sem registros"
          no-results-text="Sem registros"
          loading-text="Carregando dados..."
        >
          <template v-slot:item.local="{ item }">
            <div class="pt-1">{{ item.endereco.local }}</div>
          </template>

          <template v-slot:item.ativa="{ item }">
            <v-btn icon @click="selecionarEmpresa(item)">
              <v-icon>{{
                empresa.id === item.id
                  ? "mdi-checkbox-marked"
                  : "mdi-checkbox-blank-outline"
              }}</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-divider style="margin-top: 3px"></v-divider>
        <div class="pt-4 d-flex">
          <v-btn
            depressed
            color="primary"
            @click="$router.push('/empresas/cadastrar')"
            v-if="user.tipo == 'cliente'"
            >Nova Empresa</v-btn
          >
          <v-spacer />
          <v-btn depressed @click="$refs.dialogoSelecaoEmpresa.fechar()"
            >Cancelar</v-btn
          >
        </div>
      </as-dialogo>

      <as-dialogo
        ref="dialogoCadastroEmpresa"
        title="Cadastro de Empresa"
        max-width="800px"
        hideCloseButton
      >
        <p class="text--primary">
          Para finalizar sua compra, é necessário ter ao menos uma empresa
          cadastrada!
        </p>
        <p class="text--primary">Você ainda não cadastrou nenhuma empresa.</p>
        <p class="text--primary">
          Clique no botão abaixo para cadastrar sua primeira empresa.
        </p>
        <div slot="botoes">
          <v-btn color="white" @click="$refs.dialogoCadastroEmpresa.fechar()"
            >Cancelar</v-btn
          >
          <v-btn color="primary" @click="$router.push('/empresas/cadastrar')"
            >Cadastrar Empresa</v-btn
          >
        </div>
      </as-dialogo>

      <waiting :show="salvando"></waiting>
    </v-card>

    <busca-clientes
      ref="dialogoPesquisaCliente"
      @selecionouCliente="selecionarCliente"
    ></busca-clientes>
  </v-container>
</template>

<script>
import ServicePedidos from "@/services/pedidos.js";
import ServiceClientes from "@/services/clientes.js";
import Grade from "./Grade.vue";
import BuscaClientes from "@/views/clientes/BuscaClientes";

export default {
  name: "Checkout",
  components: {
    Grade,
    BuscaClientes,
  },
  data() {
    return {
      tab_atual: "produtos",
      loading: false,
      salvando: false,
      windowHeight: window.innerHeight,
      produto: {},
      empresas: [],
      user: {},
      empresa: {
        id: 0,
        nome_fantasia: "",
        endereco: {
          id: "",
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      },
      headers_empresas: [
        { text: "Nome", value: "nome_fantasia", width: "35%" },
        { text: "CNPJ", value: "cnpj", width: "25%" },
        {
          text: "Local",
          value: "endereco.local",
          width: "35%",
          class: "hidden-xs-only",
        },
        {
          text: "Ativa",
          value: "ativa",
          sortable: false,
          width: "5%",
          align: "end",
        },
      ],
      representante: {
        nome_fantasia: "",
        endereco: {
          id: "",
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
      },
      forma_pagamento: "Depósito",
      formas_pagamento: ["Depósito"],
      clientes: [],
      cliente: {},
      cliente_lojas: [],
      cliente_loja: {},
      form_pagamento: false,
      pagamento: {
        data: "",
        entrega: "",
        desconto_percentual: 0,
        desconto_valor: 0,
        taxa_percentual: 0,
        taxa_valor: 0,
        comissao_percentual: 5,
        comissao_valor: 0,
        comissao_tipo: "Fornecedor",
        forma_pagamento: "",
        prazo: "",
        transportadora: "",
        transportadora_telefone: "",
        vendedor: "",
        valor_bruto: 0,
        valor_liquido: 0,
        observacoes: "",
        quantidade: 0,
        pedido_loja: true,
      },
      formas_pagamento_fornecedor: [
        "À Vista",
        "Depósito",
        "Transferência",
        "Cheque",
        "Cartão de Crédito",
        "Cartão de Débito",
        "Boleto",
        "PIX",
        "Duplicata",
      ],
      rules: {
        data: [(value) => !!value || "Obrigatório"],
        entrega: [(value) => !!value || "Obrigatório"],
        forma_pagamento: [(value) => !!value || "Obrigatório"],
        prazo: [(value) => !!value || "Obrigatório"],
        vendedor: [(value) => !!value || "Obrigatório"],
        valor_zerado: [
          (value) =>
            parseFloat(value.replace(",", ".")) >= 0 ||
            "O valor não pode ser negativo",
        ],
        valor_positivo: [
          (value) =>
            (!!value && parseFloat(value.replace(",", ".")) > 0) ||
            "O valor não pode ser zero ou negativo",
        ],
      },
      prazos: [
        "15",
        "15/30",
        "15/30/45",
        "15/30/45/60",
        "15/30/45/60/75",
        "30",
        "30/60",
        "30/60/90",
        "30/60/90/120",
        "30/60/90/120/150",
        "60",
        "60/90",
        "60/90/120",
        "60/90/120/150",
      ],
      data_atual: "",
      comissao_tipo: ["Fornecedor"],
      rodada: {},
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.rodada = JSON.parse(localStorage.getItem("rodada"));
    this.getDataAtual();

    window.addEventListener("resize", () => {
      this.windowHeight =
        window.innerHeight - (this.$vuetify.breakpoint.xsOnly ? 310 : 270);
    });

    if (!this.user.cliente_id && this.user.tipo == "cliente") {
      //se o cliente não tiver preenchido as informações em Minha-Conta
      this.$router.push("/cliente/minha-conta");
    }

    if (this.user.tipo == "cliente") {
      this.carregarEmpresas();
    } else if (this.user.tipo == "representante") {
      this.carregarClientes();
    }
  },
  methods: {
    async carregarEmpresas() {
      try {
        this.empresa = {
          id: 0,
          nome_fantasia: "",
          endereco: {
            id: "",
            rua: "",
            numero: "",
            complemento: "",
            bairro: "",
            cidade_id: "",
            estado_id: "",
            cep: "",
            telefone: "",
            celular: "",
            email: "",
          },
        };

        this.loading = true;

        let cliente_id = "";

        if (this.user.tipo == "cliente") {
          cliente_id = this.user.cliente_id;
        } else if (this.user.tipo == "representante") {
          cliente_id = this.cliente.id;
        }

        let empresas_response = await ServiceClientes.listarLojas(cliente_id);

        this.empresas = empresas_response.data.lojas;
        this.representante = empresas_response.data.representante;

        this.empresas.forEach((empresa) => {
          empresa.ativa = false;
        });
        if (this.empresas.length > 0) {
          this.empresa = this.empresas[0];
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar empresas");
      } finally {
        this.loading = false;
      }
    },
    async carregarClientes() {
      try {
        this.loading = true;

        let clientes_response = await ServiceClientes.carregarClientesRepresentante(
          this.user.representante_id
        );
        this.clientes = clientes_response.data.clientes;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao listar clientes");
      } finally {
        this.loading = false;
      }
    },
    finalizarCompra() {
      if (this.user.tipo == "fornecedor") {
        if (
          this.$store.state.produtos.length > 0 &&
          this.$refs.form.validate() &&
          this.empresa.id != 0 &&
          this.form_pagamento
        ) {
          this.salvarPedidoFornecedor();
        } else {
          this.$eventbus.erro(
            "Erro ao salvar pedido! Verifique os dados e tente novamente"
          );
        }
      } else {
        this.salvarPedidoCliente();
      }
    },
    async salvarPedidoCliente() {
      try {
        if (this.empresa.id != 0) {
          this.salvando = true;
          let pedido = {
            cliente_id: this.empresa.cliente_id,
            cliente_loja: this.empresa.id,
            quantidade_total: this.quantidadeTotal,
            valor_total: this.valorTotal,
            forma_pagamento: "Depósito",
            produtos: this.$store.state.produtos,
          };

          await ServicePedidos.salvarPedidoCliente(pedido);

          this.$eventbus.notificar("Pedido salvo com sucesso");
          this.$store.state.produtos = [];
          localStorage.removeItem("carrinho");
          this.$router.push("/pedidos");
        } else {
          if (this.user.tipo == "cliente") {
            this.$refs.dialogoCadastroEmpresa.abrir();
          } else if (this.user.tipo == "representante") {
            this.tab_atual = "entrega";
          }
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao tentar salvar pedido");
      } finally {
        this.salvando = false;
      }
    },
    async salvarPedidoFornecedor() {
      try {
        this.salvando = true;

        this.pagamento.valor_bruto = this.valorTotal;
        this.pagamento.quantidade = this.quantidadeTotal;

        let pedido = {
          ...this.pagamento,
          produtos: this.$store.state.produtos,
          cliente: this.empresa,
          cliente_id: this.empresa.cliente_id,
          cliente_loja_id: this.empresa.id,
          fornecedor_id: this.user.fornecedor_id,
          representante_id: this.empresa.cliente.representante_id,
          rodada_id: this.rodada.id,
        };

        await ServicePedidos.salvar(pedido);

        this.$eventbus.notificar("Pedido salvo com sucesso");
        this.$store.state.produtos = [];
        localStorage.removeItem("carrinho");
        this.$router.push("/pedidos");
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao tentar salvar pedido");
      } finally {
        this.salvando = false;
      }
    },
    editarGrade(produto_selecionado, index) {
      this.produto = this.clone(produto_selecionado);
      produto_selecionado.indice = index;
      this.$refs.grade.abrir(produto_selecionado, true);
    },
    selecionarEmpresa(empresa_selecionada) {
      empresa_selecionada.ativa = true;
      this.empresa = this.clone(empresa_selecionada);
      this.$refs.dialogoSelecaoEmpresa.fechar();
    },
    selecionarCliente(cliente_selecionado) {
      this.empresa = this.clone(cliente_selecionado);
    },
    async getDataAtual() {
      let data_atual = await ServicePedidos.getDataAtual();
      this.data_atual = data_atual.data.data_atual;
      this.pagamento.data = data_atual.data.data_atual;
    },
    calcularValorLiquido() {
      this.pagamento.valor_liquido =
        this.valorTotal -
        this.pagamento.desconto_valor +
        this.pagamento.taxa_valor;

      this.pagamento.comissao_valor =
        (this.pagamento.valor_liquido * this.pagamento.comissao_percentual) /
        100;
    },
    calcularDescontoValor() {
      if (this.pagamento.desconto_percentual) {
        this.pagamento.desconto_valor =
          (this.valorTotal * this.pagamento.desconto_percentual) / 100;
      } else {
        this.pagamento.desconto_valor = 0;
        this.pagamento.desconto_percentual = 0;
      }
      this.calcularValorLiquido();
    },
    calcularDescontoPercentual() {
      if (this.pagamento.desconto_valor) {
        this.pagamento.desconto_percentual =
          (this.pagamento.desconto_valor / this.valorTotal) * 100;
      } else {
        this.pagamento.desconto_percentual = 0;
        this.pagamento.desconto_valor = 0;
      }
      this.calcularValorLiquido();
    },
    calcularTaxaValor() {
      if (this.pagamento.taxa_percentual) {
        this.pagamento.taxa_valor =
          (this.valorTotal * this.pagamento.taxa_percentual) / 100;
      } else {
        this.pagamento.taxa_valor = 0;
        this.pagamento.taxa_percentual = 0;
      }
      this.calcularValorLiquido();
    },
    calcularTaxaPercentual() {
      if (this.pagamento.taxa_valor) {
        this.pagamento.taxa_percentual =
          (this.pagamento.taxa_valor / this.valorTotal) * 100;
      } else {
        this.pagamento.taxa_percentual = 0;
        this.pagamento.taxa_valor = 0;
      }
      this.calcularValorLiquido();
    },
    setarValorLiquido() {
      this.pagamento.valor_liquido = this.valorTotal;
      this.calcularValorLiquido();
      this.calcularDescontoValor();
      this.calcularTaxaValor();
    },
  },
  watch: {
    update: function(value) {
      if (value) {
        document.querySelector("html").style.overflowY = "hidden";
      } else {
        document.querySelector("html").style.overflowY = "auto";
      }
    },
  },
  computed: {
    valorTotal() {
      return this.$store.state.produtos.reduce((soma, produto_atual) => {
        return produto_atual.subtotal + soma;
      }, 0);
    },
    quantidadeTotal() {
      return this.$store.state.produtos.reduce((soma, produto_atual) => {
        return soma + parseInt(produto_atual.quantidade);
      }, 0);
    },
  },
};
</script>
